export default {"src":"/_next/static/media/emojiIcon.2851732e.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};